import React, { useState, useEffect } from "react";
import useHttp from "../../../hooks/use-http";
import { toast } from "react-toastify";

const DepartmentDetailsForm = (props) => {
  const [departmentName, setdepartmentName] = useState("");
  const [departmentData, setdepartmentData] = useState([]);

  const { sendRequest: getdepartmentData } = useHttp();
  const { sendRequest: postdepartmentDetails } = useHttp();

  const FillDetail = () => {
    getdepartmentData(
      {
        url: `/api/department/?orgId=${localStorage.getItem("orgId")}`,
      },
      (res) => {
        if (res) {
          setdepartmentData(res);
        }
      },
      (error) => {
        console.log("Error", error);
      }
    );
  };

  useEffect(() => {
    FillDetail();
  }, [getdepartmentData]);

  const submitHandler = (e) => {
    e.preventDefault();
    if (!props.update) {
      const isExistingdepartment = departmentData.some(
        (department) => department.departmentName === departmentName
      );

      if (isExistingdepartment) {
        toast.error("department name already exists");
        return;
      }
    }
    const data = {
      departmentName: departmentName.trim(),
      status: 1,
      orgId: parseInt(localStorage.getItem("orgId")),
      createdBy: parseInt(localStorage.getItem("id")),
      serviceId: props.sId,
    };

   // console.log("data", data);

    if (props.update) {
      data["departmentId"] = props.update.departmentId;
    }

    postdepartmentDetails(
      {
        url: "/api/department/",
        method: props.update ? "PUT" : "POST",
        body: data,
      },
      (res) => {
        toast.success(
          `department Details ${props.update ? "Updated" : "Added"}`
        );
        props.addForm(false);
      },
      (error) => {
        toast.error(error || "Something went wrong");
        console.log(error);
      }
    );
  };

  useEffect(() => {
    if (props.update) {
      setdepartmentName(props.update.departmentName);
    }
  }, [props.update]);

  return (
    <>
      <div className="content-wrapper">
        <div>&nbsp;</div>
        <section className="content">
          <form style={{ margin: "10px" }} onSubmit={submitHandler}>
            <div className="container-fluid">
              {/* SELECT2 EXAMPLE */}
              <div className="card card-default">
                <div className="card-header">
                  <h3 className="card-title">Department Details</h3>
                  <div className="card-tools">
                    <button
                      type="button"
                      className="btn btn-tool"
                      data-card-widget="remove"
                      onClick={() => props.addForm(false)}
                    >
                      <i className="fas fa-times" />
                    </button>
                  </div>
                </div>
                {/* /.card-header */}
                <div className="card-body">
                  <div className="row">
                    <div className="col-md-4">
                      <div className="form-group">
                        <label>Department Name </label>
                        <input
                          type={"text"}
                          id={"departmentName"}
                          required
                          className="form-control"
                          value={departmentName}
                          onChange={(e) => {
                            setdepartmentName(e.target.value);
                          }}
                        />
                      </div>
                    </div>
                  </div>

                  <div className="row">
                    <div className="col-md-4"></div>
                    <div className="col-md-1"> </div>
                    <div className="col-md-1">
                      {" "}
                      <button className="btn btn-primary my-2" type="submit">
                        Add
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </form>
        </section>
      </div>
    </>
  );
};

export default DepartmentDetailsForm;
